import Amplify from 'aws-amplify';
import { AWSSettings } from '../models/aws-settings.model';


export function configureAmplify(isAgent: boolean) {
  const awsSettings: AWSSettings = JSON.parse(localStorage.getItem('awsSettings'));

    // const { identityPoolId,
    //         region,
    //         userPoolId,
    //         userPoolWebClientId } = isAgent ? AgentAuthConfig : AuthConfig;

    const identityPoolId = awsSettings.IdentityPoolId;
    const region = awsSettings.Region;
    const userPoolId = awsSettings.UserPoolId;
    const userPoolWebClientId = awsSettings.UserPoolWebClientId;
    const authenticationFlowType = awsSettings.AuthenticationFlowType;
    const bucketName = awsSettings.BucketName;

    Amplify.configure(
        {
         Auth: {
           identityPoolId,
           region,
           userPoolId,
           userPoolWebClientId,
           storage: localStorage,
           authenticationFlowType
          },
        Storage: {
           bucket: bucketName,
           region,
           identityPoolId
          }
        }
       );

}
